import React, {useEffect} from "react";
import {PhoneNumberUtil} from "google-libphonenumber";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import './KucPhoneInput.css';

export default function KucPhoneInput({
                                          label,
                                          id,
                                          value,
                                          onChange,
                                          ...restProps
                                      }) {

    const phoneUtil = PhoneNumberUtil.getInstance();

    function checkPhone(newPhone) {
        try {
            // console.log("newPhone",label, newPhone);
            return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(newPhone));
        } catch (error) {
            // console.log(error);
            return false;
        }
    }

    useEffect(() => {
        onChange(value, checkPhone(value));
    }, [value])

    function onChangeHandler(value) {
        onChange(value, checkPhone(value));
    }

    return <div>
        <label htmlFor={id}
               className="block w-full text-sm font-medium leading-6 text-white">{label}</label>
        <PhoneInput
            placeholder="Enter phone number"
            id={id}
            value={value}
            defaultCountry={"CH"}
            onChange={onChangeHandler}/>
    </div>
}